import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=5b2940c8&"
import script from "./FeedbackPage.vue?vue&type=script&lang=ts&"
export * from "./FeedbackPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports